export default __webpack_public_path__ + "static/arcx-a5cfad3dd1f48e57a67685e644825b93.jpg";